import { Component } from '@angular/core';

@Component({
  selector: 'app-pagenotfound',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent  {

  //constructor() { }



}
